"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var FieldHelper = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArrays(["c-field__help-text"], utilityClasses);
    return react_1.default.createElement("span", { className: classes.join(" ") }, props.children);
};
var FieldGroupLayout;
(function (FieldGroupLayout) {
    FieldGroupLayout["Inline"] = "+inline";
    FieldGroupLayout["Stacked"] = "+stacked";
})(FieldGroupLayout || (FieldGroupLayout = {}));
var FieldGroup = function (props) {
    var _a;
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArrays(["c-field-group", (_a = props.layout) !== null && _a !== void 0 ? _a : FieldGroupLayout.Stacked], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
FieldGroup.Layout = FieldGroupLayout;
var FieldSetLayout;
(function (FieldSetLayout) {
    FieldSetLayout["Inline"] = "+inline";
    FieldSetLayout["Stacked"] = "+stacked";
    FieldSetLayout["Fill"] = "+fill";
})(FieldSetLayout || (FieldSetLayout = {}));
var FieldSet = function (props) {
    var _a;
    var legend = props.legend;
    var layoutOptions = (_a = props.layoutOptions) !== null && _a !== void 0 ? _a : [FieldSetLayout.Fill, FieldSetLayout.Inline];
    var classes = __spreadArrays(["c-form"], layoutOptions, distillUtilityClasses_1.default(props));
    return (react_1.default.createElement("fieldset", { className: classes.join(" ") },
        legend && react_1.default.createElement("legend", null, legend),
        props.children));
};
FieldSet.Layout = FieldSetLayout;
//# sourceMappingURL=Field.js.map